import MeetingComment, {CommentAttachment, CommentReactedUser, CommentUser} from './MeetingComment'

export default class MeetingCommentReply extends MeetingComment {
    replySourceId: number

    constructor(
        meetingCommentId: number,
        replySourceId: number,
        content: string,
        user: CommentUser,
        updateDatetime: string,
        commentReactedUserList: CommentReactedUser[],
        attachmentList: CommentAttachment[],
        isYou: boolean,
        version: number,
    ) {
        super(meetingCommentId, content, user, updateDatetime, commentReactedUserList, attachmentList, isYou, version)
        this.replySourceId = replySourceId
    }
}
